import { useRef, useState } from "react";
import { endpoints } from "../../hooks/endpoints";
import { getToken } from "../../hooks/utils";
import Animation from "../Animation";

import { getHostname } from "@/scripts/getHostname";
import { toast } from "sonner";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { pushModal } from "../../store/slices/modalsSlice";
import {
  invokePortalRefetch,
  invokeUserRefetch,
} from "../../store/slices/storeSlice";
import GeneralMessageModal from "../Modals/GeneralMessageModal";
import Spinner from "../Spinner";
import { Button } from "../ui/button";
import DynamicCategorySelector from "./DynamicCategorySelector";
import { useFilteredPortalData } from "../../hooks/useFilteredPortalData";

const ManageGrades = () => {
  const [loading, setLoading] = useState(false);
  const newCatRef = useRef<any>();
  const remCatRef = useRef<any>();
  const gradeRef = useRef<any>();
  const dispatch = useAppDispatch();

  const { portal } = useAppSelector((state) => state.store);
  const { filteredCats } = useFilteredPortalData();

  const cats = filteredCats?.filter((item) => item.parent !== 0) ?? [];
  const grades = filteredCats?.filter((item) => item.parent === 0) ?? [];

  const manageCat = ({ cat, type }) => {
    if (cat === "")
      return dispatch(
        pushModal(<GeneralMessageModal msg="أدخل إسم القسم" btnMsg="حسنا" />)
      );
    if (!gradeRef.current?.value && type === "add")
      return dispatch(
        pushModal(
          <GeneralMessageModal
            msg="أدخل القسم الرئيسي لهذا القسم"
            btnMsg="حسنا"
          />
        )
      );

    setLoading(true);

    if (type === "add" && cats.includes(cat.trim().toLowerCase()))
      return dispatch(
        pushModal(
          <GeneralMessageModal msg="القسم موجودة بالفعل" btnMsg="حسنا" />
        )
      );

    fetch(
      endpoints.manageTeacherCats +
        `?cat_id=${cat}&cat=${cat.trim()}&grade=${
          gradeRef?.current?.value
        }&type=${type}&portal=${getHostname()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw Error();
        }
        return res.json();
      })
      .then((data) => {
        toast.success(
          <span className="text-green-700">
            {type === "add" ? "تم انشاء القسم بنجاح" : "تم حذف القسم بنجاح"}
          </span>
        );
      })
      .catch((err) => {
        console.log(err);
        toast.success(<span className="text-red-600">حدث خطأ</span>);
      })
      .finally(() => {
        setLoading(false);
        gradeRef.current.value = "";
        newCatRef.current.value = "";
        remCatRef.current.value = "";
        dispatch(invokePortalRefetch());
        dispatch(invokeUserRefetch());
      });
  };

  return (
    <Animation>
      <div className="space-y-6">
        <h3 className="bg-primary p-3 text-white rounded-lg shadow font-bold">
          إدارة الأقسام الدراسية
        </h3>

        <div className="bg-white rounded-lg shadow-sm p-3 border space-y-4">
          <h3 className="py-2 font-bold border-b-2 border-primary w-fit">
            إنشاء قسم دراسي جديد
          </h3>

          <div className="mb-3">
            <input
              ref={newCatRef}
              type="text"
              placeholder="أدخل الإسم"
              id="newCat"
              className="block w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          <p className="mb-3">إختر القسم الرئيسي لهذا القسم</p>

          <DynamicCategorySelector
            excludeCatsThatHasLessons={true}
            showLessonsSelector={false}
            fieldRef={gradeRef}
            isCreatingNewCategory={true}
          />

          <Button
            disabled={loading}
            onClick={() =>
              manageCat({
                cat: newCatRef.current.value,
                type: "add",
              })
            }
            className="rounded-lg px-4 py-2"
            type="button"
          >
            {loading ? <Spinner variant="button" /> : "إنشاء"}
          </Button>
        </div>

        <div className="p-3 bg-white border rounded-lg shadow-sm">
          <div className="space-y-4">
            <h3 className="py-2 font-bold border-b-2 border-primary w-fit">
              حذف قسم دراسي
            </h3>

            <DynamicCategorySelector
              excludeCatsThatHasLessons={false}
              showLessonsSelector={false}
              fieldRef={remCatRef}
              isCreatingNewCategory={false}
            />

            <Button
              className="bg-primary rounded-lg px-4 py-2"
              type="button"
              disabled={loading}
              onClick={() =>
                manageCat({
                  cat: remCatRef.current.value,
                  type: "remove",
                })
              }
            >
              حذف
            </Button>
          </div>
        </div>
      </div>
    </Animation>
  );
};

export default ManageGrades;
